import React, { useEffect, useMemo, useState } from 'react'

import {
  Card,
  CardBody,
  Col,
  Container,
  Row
} from "reactstrap";
import TableContainerV1 from "components/Common/TableContainerV1";
import { getBank } from '../../http/fundLync/bank.helper'
import Breadcrumbs from 'components/Common/BreadcrumbTitle';

const BankList = () => {
  document.title = "List Bank | Fundlync";

  const [bankList, setBankList] = useState([]);
  const [pagination, setPagination] = useState({ pageIndex: 0, pageCount: 0, totalRecords: 0 });
  const [pageSize, setPageSize] = useState(10);
  const [columnId, setColumnId] = useState("id");
  const [searchValue, setSearchValue] = useState("");
  const [sortingOptions, setSortingOptions] = useState({ column: 'id', isAsc: false, optionalColumn: ['Action'] })
  const [sortingOrderStatus, setSortingOrderStatus] = useState("desc");

  const columns = useMemo(() => [
    {
      Header: 'Id',
      accessor: 'id',
      filterable: true,
    },
    {
      Header: 'Bank Name',
      accessor: 'bankName',
      filterable: true,
    },
    {
      Header: 'Bank Id',
      accessor: 'bankId',
      filterable: true,
    }
  ], [])

  const handlePageChange = async (page, pageSize, searchKey, columnName = columnId, sortingOrder = sortingOrderStatus) => {
    try {
      setPageSize(pageSize);
      let data = await getBank({ page, limit: pageSize, searchKey, columnName, sortingOrder })
      setBankList(data.data.data);
      const { totalItems, totalPages, currentPage } = data.data
      if(data.data){
        setPagination({ pageIndex: currentPage, pageCount: totalPages, totalRecords: totalItems })
      }
    } catch (error) {
      setPagination({ pageIndex: 0, pageCount: 0, totalRecords: 0 })
      setBankList([]);
    }
  }

  const handleSortColumn = (option) => {
    setSortingOptions(option)
    const columnName = option.column;
    setColumnId(columnName)
    let sortingOrder = option.isAsc ? "asc" : "desc";
    setSortingOrderStatus(sortingOrder)
    handlePageChange(1, pageSize, searchValue, columnName, sortingOrder)
  }

  const handleSearchFilter = (value, pageSize) => {
    setSearchValue(value)
    handlePageChange(1, pageSize, value);
  }

  const handleClearSearch = () => {
    setSearchValue("")
    handlePageChange(1, pageSize, "")
  }

  useEffect(() => {
    (async () => {
      try {
        let bankData = await getBank();
        if (bankData.code === 200) {
          setBankList(bankData.data.data)
          const { totalItems, totalPages, currentPage } = bankData.data
          setPagination({ pageIndex: currentPage, pageCount: totalPages, totalRecords: totalItems })
        }
      } catch (error) {
        setBankList([]);
      }
    })()
  }, [])

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid className='m-20'>
          <Breadcrumbs title="BANK LIST"/>
          <Row className="vertical-scroll">
            <Col xs="12">
              <Card>
                <CardBody>
                  <TableContainerV1
                    columns={columns}
                    data={bankList}
                    pagination={pagination}
                    handlePageChange={handlePageChange}
                    handleSearchFilter={handleSearchFilter}
                    sortOptions={sortingOptions}
                    handleSortColumn={handleSortColumn}
                    handleClearSearch={handleClearSearch}
                    className="custom-header-css"
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default BankList
